import React from 'react'

import { Link } from 'react-router-dom';

const RemoteSensing = () => {

    

    return (
        <>
            <marquee behavior="scroll" scrollamount="14" bgcolor="#fdc800" height="40pxl">
                <h3> Remote Sensing and GIS Institute Registration Apply Easy 3 Step</h3>
            </marquee>


            <div className="slider1-area overlay-default">
                <div className="bend niceties preview-1">
                    <div id="ensign-nivoslider-3" className="slides">
                        <img src="/images/Gis_img/gis_1.jpg" alt="slider" title="#slider-direction-1" />
                        <img src="/images/Gis_img/gis_2.jpg" alt="slider" title="#slider-direction-2" />

                    </div>
                    <div id="slider-direction-1" className="t-cn slider-direction">
                        <div className="slider-content s-tb slide-1">
                            <div className="title-container s-tb-c">
                                <div className="slider-btn-area">
                                    <Link to='/contact' target='_blank' className="join-now-btn">Admission Enquiry</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="slider-direction-2" className="t-cn slider-direction">
                        <div className="slider-content s-tb slide-2">
                            <div className="title-container s-tb-c">
                                <div className="slider-btn-area">
                                    <Link to='/contact' target='_blank' className="join-now-btn">Admission Enquiry</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>


            <div className="shop-details-page-area pt-5">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-18 col-md-18 col-sm-18 col-xs-18 col-md-push-3">
                            <div className="inner-shop-details">
                                <div className="product-details-info-area">
                                    <div className="row">
                                        <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                                            <div className="inner-product-details-left">
                                                <div className="featured-box">
                                                    <div className="featured-img-holder hvr-bounce-to-right">
                                                        <img src="/images/Gis_img/ittcouncil_GIS1.jpg" className="img-responsive" alt="featured" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                                            <div className="inner-product-details-right">
                                                <h3>Diploma in Remote Sensing and GIS Training </h3>
                                                <ul className="learning-outcomes">
                                                    This course gives you real insights in the industry of the tools used and process involved. This covers all the tools needed to work in this field and create a real world impact.<br />
                                                    <li>Geographic Inormation System (GIS)</li><br />
                                                    <li>Remote Sensing (RS)</li><br />
                                                    <li>Fundamentals of Geoinformatics</li><br />
                                                    <li>Spatial Data Analysis &amp; Modeling</li><br />
                                                    <li>Aerial Photography and Photogrammetry</li><br />
                                                    <li>Application of RS and GIS</li><br />
                                                    <li>Diploma Certificate With 1 Sem &amp; 2 Sem Marks Statement </li><br />
                                                </ul></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="container">
                    <div className="row">
                        <div className="col-lg-18 col-md-18 col-sm-18 col-xs-18 col-md-push-3">
                            <div className="inner-shop-details">
                                <div className="product-details-info-area">
                                    <div className="row">
                                        <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                                            <div className="inner-product-details-left">
                                                <div className="featured-box">
                                                    <div className="featured-img-holder hvr-bounce-to-right">
                                                        <img src="/images/Gis_img/ittcouncil_GIS2.jpg" className="img-responsive" alt="featured" />
                                                    </div></div>
                                            </div></div>
                                        <div className="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                                            <div className="inner-product-details-right">
                                                <h3>Advance Course In GIS And Remote Sensing Training </h3>
                                                <ul className="learning-outcomes">
                                                    This course covers the advanced topics in this field with hands on experience on the tools available.<br />
                                                    <li>Geographic Inormation System (GIS)</li><br />
                                                    <li>Remote Sensing (RS)</li><br />
                                                    <li>Fundamentals of Geoinformatics</li><br />
                                                    <li>Advanced Geographic Information System</li><br />
                                                    <li>Spatial Data Analysis & Modeling</li><br />
                                                    <li>Advamce Course Certificate With Marks Statement</li><br />
                                                </ul></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="news-event-area">
                <div className="container">
                    <div className="row pb-5">
                        <h2 className="title-default-center title-bar-counter">GIS Short Term & Certificate Courses</h2>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 news-inner-area">
                            <ul className="news-wrapper">
                                <li className="wow bounceInUp" data-wow-duration="2s" data-wow-delay=".1s">
                                    <div className="news-img-holder">
                                        <a href="#"><img src="/images/gis-img.jpg" className="img-responsive" alt="news" /></a>
                                    </div>
                                    <div className="news-content-holder">
                                        <h3><a href="single-news.html"> Basic Course in GIS and Remote Sensing Training</a></h3>
                                        <p > This course covers the basics of remote sensing and GIS to get you familiar with the recent trends in the industry. This course has no pre-requisites.</p>
                                    </div>
                                </li>

                            </ul>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 news-inner-area ">
                            <ul className="news-wrapper">
                                <li className="wow bounceInUp" data-wow-duration="2s" data-wow-delay=".1s">
                                    <div className="news-img-holder">
                                        <a href="#"><img src="/images/gis-img2.jpg" className="img-responsive" alt="news" /></a>
                                    </div>
                                    <div className="news-content-holder" style={{ paddingBottom: '72px' }}>
                                        <h3><a href="single-news.html">One Month Certificate Course in GIS</a></h3>
                                        <p className>This course covers the basics of GIS.</p>
                                    </div>
                                </li>


                            </ul>

                        </div>
                        {/* <div className="d-flex justify-content-center mt-4">
                            <div className="news-btn-holder">
                                <a href="#" className="view-all-accent-btn ">View Courses</a>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>

            <h2 className="title-center pt-4">Benefits of GIS Courses</h2>
            <div className='container'>
                <div className="row p-3">
                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <div className="featured-box2 hvr-bounce-to-right">
                            <i className="fa fa-map-pin" aria-hidden="true" />
                            <h3><a href="#">Asset Mapping</a></h3>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <div className="featured-box2 hvr-bounce-to-right">
                            <i className="fa fa-line-chart" aria-hidden="true" />
                            <h3><a href="#">Black Spot Analysis</a></h3>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <div className="featured-box2 hvr-bounce-to-right">
                            <i className="fa fa-gavel" aria-hidden="true" />
                            <h3><a href="#">Crime Mapping</a></h3>
                        </div>
                    </div>
                </div>

                <div className="row p-3">
                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <div className="featured-box2 hvr-bounce-to-right">
                            <i className="fa fa-map-marker" aria-hidden="true" />
                            <h3><a href="#">Cadastral Mapping</a></h3>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <div className="featured-box2 hvr-bounce-to-right">
                            <i className="fa fa-database" aria-hidden="true" />
                            <h3><a href="#">Land base data creation</a></h3>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <div className="featured-box2 hvr-bounce-to-right">
                            <i className="fa fa-map-pin" aria-hidden="true" />
                            <h3><a href="#">Topographic Survey</a></h3>
                        </div>
                    </div>
                </div>

                <div className="row p-3">
                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <div className="featured-box2 hvr-bounce-to-right">
                            <i className="fa fa-cogs" aria-hidden="true" />
                            <h3><a href="#">Engineering Survey</a></h3>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <div className="featured-box2 hvr-bounce-to-right">
                            <i className="fa fa-road" aria-hidden="true" />
                            <h3><a href="#">Road Survey</a></h3>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <div className="featured-box2 hvr-bounce-to-right">
                            <i className="fa fa-subway" aria-hidden="true" />
                            <h3><a href="#">Railway Survey</a></h3>
                        </div>
                    </div>
                </div>



                <div className="row p-3">
                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <div className="featured-box2 hvr-bounce-to-right">
                            <i className="fa fa-th-large" aria-hidden="true" />
                            <h3><a href="#">Grid Survey</a></h3>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <div className="featured-box2 hvr-bounce-to-right">
                            <i className="fa fa-space-shuttle" aria-hidden="true" />
                            <h3><a href="#">Contour Survey</a></h3>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <div className="featured-box2 hvr-bounce-to-right">
                            <i className="fa fa-map-marker" aria-hidden="true" />
                            <h3><a href="#">GPS</a></h3>
                        </div>
                    </div>
                </div>

                <div className="row p-3">
                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <div className="featured-box2 hvr-bounce-to-right">
                            <i className="fa fa-map" aria-hidden="true" />
                            <h3><a href="#">DGPS</a></h3>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <div className="featured-box2 hvr-bounce-to-right">
                            <i className="fa fa-user" aria-hidden="true" />
                            <h3><a href="#">Total Station</a></h3>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <div className="featured-box2 hvr-bounce-to-right">
                            <i className="fa fa-level-up" aria-hidden="true" />
                            <h3><a href="#">Auto Level</a></h3>
                        </div>
                    </div>
                </div>



            </div>
            <h2 className='title-center pt-3'>Careers in GIS and Remote Sensing</h2>
            <div className='container'>
                <p className=' ' style={{ textAlign: 'justify' }}>Today every area ranging from missile and unmanned aerial vehicle technology to urban administration, e-governance, remote sensing, energy sector, and even advertising and marketing depend on geospatial data. GIS and Remote Sensing are two exciting areas of technology to work on. But, what exactly are GIS and remote sensing? How do they work? WhatHow are the career scopes in GIS and remote sensing?<br /><br />A geographic information system (GIS) is a framework for gathering, managing, and analyzing data. Rooted in the science of geography, GIS integrates many types of data. It analyzes spatial location and organizes layers of information into visualizations using maps and 3D scenes.
                </p>

                <div className='d-flex justify-content-center ' >
                    <img className='img-responsive pt-3 pb-4' src='/images/Gis_img/ittcouncil_GIS1.jpg'></img>
                </div>

                <h2 className='title-center'>Introduction to Geographic Information System (GIS)</h2>
                <p style={{ textAlign: 'justify' }}>Geographic information system (GIS) is a special system which is designed to capture, store, manipulate, analyze, manage, and present all types of geographical data on earth. GIS technology is an integrated database which has all the information like population characteristics, economic development opportunities, and vegetation types, maps etc. GIS allows to link the databases and maps and create dynamic displays. It also provides tools to visualize, query, and overlay the databases which are technically not possible through spreadsheets.</p>
                <h2 className='title-center'>How do GIS and Remote Sensing work</h2>
                <p style={{ textAlign: 'justify' }}>Geographic science utilizes GIS technology. Remote sensors are integrated into the GIS system and this together helps in understanding the maps, weather conditions, population density and many things related to earthly conditions.</p>
                <div className='d-flex justify-content-center ' >
                    <img className='img-responsive pt-3 pb-4' src='/images/Gis_img/ittcouncil_GIS3.png'></img>
                </div>
                <h2 className='title-center'>Applications of GIS</h2>
                <p>The automation of GIS is not only used for mapping. It is also used in various fields like</p>
                <ul className="learning-outcomes pb-4">
                    <li>Petroleum- For finding petroleum refineries.</li>
                    <li>Telecommunications- For maintaining the network signals.</li>
                    <li>Transportation- To understand the traffic and mobility on roads.</li>
                    <li>Real Estate- To survey the land registrations.</li>
                    <li>Manufacturing- To identifying the mineral ores.</li>
                    <li>Natural & Sustainable Resources- To identify geographical resources.</li>
                    <li>Many other sectors like Education, Government, Health, Insurance, Public Safety, Retail, Electric and Gas Utilities etc make use of GIS systems for various purposes.</li>
                </ul>
            </div>




        </>
    )
}

export default RemoteSensing